// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__1Oyt-","image":"style_image__3KD8G","sale":"style_sale__FP-t3","des":"style_des__2zmQg"};